import { render, staticRenderFns } from "./day-configurator-practical-details.vue?vue&type=template&id=25a0fb31&scoped=true&"
import script from "./day-configurator-practical-details.vue?vue&type=script&lang=js&"
export * from "./day-configurator-practical-details.vue?vue&type=script&lang=js&"
import style0 from "./day-configurator-practical-details.vue?vue&type=style&index=0&id=25a0fb31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a0fb31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a0fb31')) {
      api.createRecord('25a0fb31', component.options)
    } else {
      api.reload('25a0fb31', component.options)
    }
    module.hot.accept("./day-configurator-practical-details.vue?vue&type=template&id=25a0fb31&scoped=true&", function () {
      api.rerender('25a0fb31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/day-configurator/day-configurator-practical-details.vue"
export default component.exports